"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListSkeleton = void 0;
var React = require("react");
var DropList_styles_1 = require("./DropList.styles");
exports.DropListSkeleton = React.forwardRef(function (_a, ref) {
    var children = _a.children, OnCloseMenu = _a.OnCloseMenu, _b = _a.PositionAbsolute, PositionAbsolute = _b === void 0 ? false : _b, Style = _a.Style, Placement = _a.Placement;
    var zIndex = Style ? Style.zIndex : 0;
    var containerRef = React.useRef(null);
    var _c = React.useState(), replacer = _c[0], setReplacer = _c[1];
    var handleBackClicked = function (e) {
        e.stopPropagation();
        if (OnCloseMenu) {
            OnCloseMenu();
        }
    };
    React.useEffect(function () {
        var container = containerRef.current;
        var searchList = [];
        var dropListItemList = [];
        for (var _i = 0, _a = Array.from(container.children); _i < _a.length; _i++) {
            var child = _a[_i];
            for (var _b = 0, _c = Array.from(child.children); _b < _c.length; _b++) {
                var grandChild = _c[_b];
                if (grandChild.getAttribute("type") === "search") {
                    searchList.push(grandChild);
                }
                else if (grandChild.tagName === "LI") {
                    dropListItemList.push(grandChild);
                }
            }
        }
        if (searchList.length > 0) {
            searchList[0].focus();
        }
        else if (dropListItemList.length > 0) {
            dropListItemList[0].firstChild.focus();
        }
    }, []);
    return (Boolean(replacer) ? replacer :
        (React.createElement(React.Fragment, null,
            React.createElement(DropList_styles_1.ClickWrapper, { style: { zIndex: zIndex }, onClick: handleBackClicked }),
            React.createElement("div", { onClick: handleBackClicked, ref: ref, style: Style, "data-placement": Placement },
                React.createElement(DropList_styles_1.ListSkeletonWrapperDiv, { PositionAbsolute: PositionAbsolute, ref: containerRef, role: "menu" }, React.Children.map(children, function (child) { return !Boolean(child) ? child : React.cloneElement(child, {
                    OnCloseMenu: OnCloseMenu,
                    SetReplacer: setReplacer,
                    Style: Style,
                }); }))))));
});
